import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Collapse } from 'react-collapse';
import {
  saveFilterParam,
  saveSortParam,
  clearSearchParams,
  filterDish,
} from '../../../actions/dishSearch';

import { getTags } from '../../../actions/tags/getTags';
import SortBar from './SortBar/SortBar';
import FilterByTags from './FilterByTags';
import ArrowIcon from '../../../images/arrow.png';

class FilterBar extends Component {
  state = {
    isOpened: false,
  };

  componentDidMount() {
    const { tags, getTags } = this.props;
    !tags.length && getTags();
  }

  open = () => {
    const { isOpened } = this.state;
    this.setState({ isOpened: !isOpened });
  };

  handleSortCheck = (event) => {
    const { saveSortParam } = this.props;
    saveSortParam(event.target.value, event.target.getAttribute('order'));
  };

  onChooseTagForSearch = (tagId) => {
    const { filterParam, saveFilterParam } = this.props;
    const newFilterParams = JSON.parse(JSON.stringify(filterParam));
    if (newFilterParams.includes(tagId)) {
      const filteredFilterPatams = newFilterParams.filter(
        (filteredTagId) => filteredTagId !== tagId,
      );
      saveFilterParam(filteredFilterPatams);
      return;
    }

    newFilterParams.push(tagId);
    saveFilterParam(newFilterParams);
  };

  render() {
    const {
      sortParam,
      searchParam,
      filterParam,
      order,
      filterDish,
      clearSearchParams,
      tags,
    } = this.props;
    const { isOpened } = this.state;
    const sort = sortParam.slice(0, -1);
    return (
      <FilterWrapper>
        <FilterTitle onClick={this.open}>
          Фильтрация
          <Img src={ArrowIcon} alt="arrow" isOpened={isOpened} />
        </FilterTitle>
        <Collapse isOpened={isOpened}>
          <FilterContainer>
            <FilterByTags
              tags={tags}
              onChooseTagForSearch={this.onChooseTagForSearch}
              choosedFiltersIds={filterParam}
            />
            <SortBar handleCheck={this.handleSortCheck} checked={sortParam} />
            <ButtonsWrapper>
              <Button onClick={() => filterDish(searchParam, filterParam, sort, order, true)}>
                Применить
              </Button>
              <ButtonClear onClick={clearSearchParams}>Сбросить фильтры</ButtonClear>
            </ButtonsWrapper>
          </FilterContainer>
        </Collapse>
      </FilterWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  const { searchParam, filterParam, sortParam, order } = state.searchParams;
  const { tags } = state.getTags;
  return {
    tags,
    searchParam,
    filterParam,
    sortParam,
    order,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    filterDish: (searchValue, tags, sortParam, order, rendering) => {
      dispatch(filterDish(searchValue, tags, sortParam, order, rendering));
    },
    saveFilterParam: (filterParam) => {
      dispatch(saveFilterParam(filterParam));
    },
    saveSortParam: (sortParam, order) => {
      dispatch(saveSortParam(sortParam, order));
    },
    clearSearchParams: () => {
      dispatch(clearSearchParams());
    },
    getTags: () => {
      dispatch(getTags());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterBar);

const FilterWrapper = styled.div`
  width: 80%;
  margin: 15px auto;
  box-sizing: border-box;
`;

const FilterTitle = styled.h3`
  width: 100%;
  height: 40px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  line-height: 40px;
  cursor: pointer;
  background: #157aac;
  color: #fff;
  border-radius: 5px;
  box-sizing: border-box;
  &:hover {
    background: #4f93c3;
    border: 1px solid #000542;
  }
`;

const Img = styled.img`
  margin-left: 25px;
  width: 25px;
  height: 25px;
  transition: 0.3s;
  transform: ${(props) => (props.isOpened ? 'rotate(180deg)' : '')};
`;

const FilterContainer = styled.div`
  padding: 15px 0;
  width: 100%;
  box-sizing: border-box;
  border-radius: 5px;
  border: 2px solid #c1c1c1;
`;

const ButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
`;

const Button = styled.div`
  width: 250px;
  height: 40px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  margin: 0 15px;
  cursor: pointer;
  font-size: 16px;
  background: #157aac;
  color: #fff;
  border: none;
  border-radius: 5px;
  &:hover {
    background: #4f93c3;
    border: 1px solid #000542;
  }
`;

const ButtonClear = Button.extend`
  background: #db2828;
  &:hover {
    background: #d01919;
    border: 1px solid #000542;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Dishes/FilterBar/FilterBar.jsx